import React from 'react';
import {
  escapeHtmlEntities,
  renderMjml,
} from '@wix/wix-emails-mjml-render-utils';
import mjmlBrowser from 'mjml-browser';
import { parser } from 'posthtml-parser';
import { sanitizeCustomHtmlBlocksInMjml } from '@wix/wix-emails-commons/mjml';
import { getCleanUserHtmlWithMetadata } from '@wix/wix-emails-secure-components';
import { type FontFamily } from '@wix/ambassador-emails-email-marketing-v1-font/types';

import { useCampaign } from '../../contexts';
import { useLpPageView } from '../../hooks';

import { AstNode } from './AstNode';

interface MjmlViewerProps {
  customFonts?: FontFamily[];
}

export const MjmlViewer = ({ customFonts }: MjmlViewerProps) => {
  const campaign = useCampaign();

  useLpPageView();

  const html = renderMjml({
    mjml: sanitizeCustomHtmlBlocksInMjml(
      campaign.data.composerData.mjml,
      (customHtml) => getCleanUserHtmlWithMetadata(customHtml).html,
    ),
    preheader: escapeHtmlEntities(campaign.data.subject || ''),
    t: () => '',
    mjml2html: mjmlBrowser,
    options: { showAd: false },
    customFonts,
  });

  const parsedHtmlTree = parser(html, { recognizeSelfClosing: true });

  return (
    <>
      {parsedHtmlTree
        .filter((node) => typeof node !== 'string')
        .map((node) => (
          // key generated randomly, not expecting LP rerenders
          <AstNode node={node} key={`${Math.random()}`} />
        ))}
    </>
  );
};
